import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editEmail, selectBuscarUsuarioEmail } from './buscarUsuarioSlice';

// eslint-disable-next-line react/prop-types
export default function BuscarUsuario({onClickHandler}) {
    const searchEmail = useSelector(selectBuscarUsuarioEmail);
    const dispatch = useDispatch();

    function onChangeHandler({target}) {
        const userInput = target.value;
        dispatch(editEmail({
            key: 'email',
            value: userInput
        }));
    }

    return (
        <>
            <form id='search-box'>
                <label htmlFor="termino">Login de usuario: </label>
                <input type="text" id="termino" name="termino"
                    value={searchEmail || ''}
                    onChange={onChangeHandler} />
                <button className="boton-barra" id="borrar" onClick={onClickHandler}>X</button>
                <button className="boton-barra" id="crear" onClick={onClickHandler}>Añadir</button>
            </form>
        </>
    );
}
